import ApiService from "@/core/services/api.service";

// action types
export const GET_LIQUIDACIONES = "getLiquidaciones";
export const GET_LIQUIDACION_CORREDOR = "getLiquidacionesCorredor";
export const GET_LIQUIDACION_ID = "getLiquidacionId";
export const GET_LIQUIDACIONES_CORREDOR = "getLiquidacionesCorredorLista";
export const GET_CONCILIACION = "createOrder";
export const GET_PERMITIR_SUBIR_DOCUMENTOS = "getBloquearSubirDocumentos";
export const UPDATE_CONCILIACION = "updateConciliacion";
export const DESCARGAR_CHEQUE = "descargarCheque";
export const DESCARGAR_BOLETA_FACTURA = "descargarBoletaFactura";
export const DESCARGAR_DETALLE_COMISION = "descargarDetalleComision";
export const DESCARGAR_DETALLE_LIQUIDACION = "descargarDetalleLiquidacion";
export const SUBIR_ARCHIVO_BOLETA_FACTURA = "crearBoletaFactura";
export const APROBAR_BOLETA_FACTURA = "aprobarBoletaFactura";
export const GET_CALENDARIO_MONTH_DATA = "getMonthCalendarioData";
// mutation types
export const SET_CONCILIACIONES = "setConciliaciones";
export const SET_ORDERS = "setOrders";
export const SET_ORDER = "setOrder";
export const SET_DETAILS = "setDetails";
export const SET_ERROR = "setError";

//const url = 'https://apifacturacionbot.contemporaseguros.com/facturacioncomisionapi'
//const url = 'https://localhost:44340'

const state = {
  errors: null,
  conciliaciones: [],
  methods: [],
  orders: [],
  order: null,
};

const actions = {
  [GET_LIQUIDACIONES](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Liquidacion/v1/liquidacion` }, "")
        .then(({ data }) => {
          context.commit(SET_CONCILIACIONES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log(("err" + response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
  [GET_LIQUIDACION_CORREDOR](context, datos) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Liquidacion/v1/liquidacion/${datos.rutCorredor}/${datos.mes}/${datos.anio}/${datos.codigoAgente}` }, "")
      // Dev
    //   ApiService.get({ action: `/api/Liquidacion/v1/liquidacion/${datos.rutCorredor}/${datos.mes}/${datos.anio}/${datos.codigoAgente}` }, "")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, ""); //response.data.errors);
          reject(response);
        });
    });
  },
  [GET_LIQUIDACION_ID](context, datos) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Liquidacion/v1/ObtenerLiquidacionId/${datos.liquidacionId}` }, "")
      // Dev
    //   ApiService.get({ action: `/api/Liquidacion/v1/ObtenerLiquidacionId/${datos.liquidacionId}` }, "")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, "");
          reject(response);
        });
    });
  },
  [GET_LIQUIDACIONES_CORREDOR](context, datos) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Liquidacion/v1/liquidacion/${datos.rutCorredor}/${datos.mes}/${datos.anio}` }, "")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, ""); //response.data.errors);
          reject(response);
        });
    });
  },
  [UPDATE_CONCILIACION](context, conciliacion) {
    return new Promise((resolve, reject) => {
      ApiService.put(
        {
          action: `/facturacioncomisionapi/api/Conciliacion/v1/conciliacion/${conciliacion.codigoConciliacion}`,
        },
        conciliacion
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [DESCARGAR_CHEQUE](context, chequeId) {
    return new Promise((resolve, reject) => {
      ApiService.get({
        action: `/facturacioncomisionapi/api/Conciliacion/v1/cheque/${chequeId}`
      }, '')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [SUBIR_ARCHIVO_BOLETA_FACTURA](context, datos) {
    return new Promise((resolve, reject) => {
      ApiService.post({ action: `/facturacioncomisionapi/api/liquidacion/v1/subirArchivoBoletaFactura` }, datos)
      // Dev
    //   ApiService.post({ action: `/api/liquidacion/v1/subirArchivoBoletaFactura` }, datos)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, ""); //response.data.errors);
          reject(response);
        });
    });
  },
  [APROBAR_BOLETA_FACTURA](context, datos) {
    return new Promise((resolve, reject) => {
      ApiService.update({ action: `/facturacioncomisionapi/api/liquidacion/v1/aprobarLiquidacion` }, datos.LiquidacionId, datos)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response)
          context.commit(SET_ERROR, ""); //response.data.errors);
          reject(response);
        });
    });
  },
  [DESCARGAR_BOLETA_FACTURA](context, liquidacionId) {
    return new Promise((resolve, reject) => {
      ApiService.get({
        action: `/facturacioncomisionapi/api/liquidacion/v1/boletaFactura/${liquidacionId}`
      }, '')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESCARGAR_DETALLE_COMISION](context, datos) {
    return new Promise((resolve, reject) => {
      ApiService.get({
          action: `/facturacioncomisionapi/api/liquidacion/v1/obtieneDetalleComision/${datos.rutCorredor}/${datos.mes}/${datos.anio}/${datos.esDetalle}`
        // }, '')
        // Dev
        // action: `/api/liquidacion/v1/obtieneDetalleComision/${datos.rutCorredor}/${datos.mes}/${datos.anio}/${datos.esDetalle}`
      }, '')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESCARGAR_DETALLE_LIQUIDACION](context, datos) {
    return new Promise((resolve, reject) => {
      ApiService.get({
          action: `/facturacioncomisionapi/api/liquidacion/v1/obtieneDetalleComision/${datos.rutCorredor}/${datos.mes}/${datos.anio}/${datos.esDetalle}`
        // }, '')
        // Dev
        // action: `/api/liquidacion/v1/obtieneDetalleComision/${datos.rutCorredor}/${datos.mes}/${datos.anio}/${datos.esDetalle}`
      }, '')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_PERMITIR_SUBIR_DOCUMENTOS](context, datos) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Liquidacion/v1/permitirSubirDocumentos` }, "")
      // Dev
    //   ApiService.get({ action: `/api/Liquidacion/v1/permitirSubirDocumentos` }, "")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, "");
          reject(response);
        });
    });
  },
  [GET_CALENDARIO_MONTH_DATA](context, datos) {
    return new Promise((resolve, reject) => {
      ApiService.getNew({
        action: `/facturacioncomisionapi/api/CalendarioPagos/v1/ObtenerDataCalendario?Mes=${datos.mes}&Anio=${datos.anio}`
      })
        // action: `/api/CalendarioPagos/v1/ObtenerDataCalendario?Mes=${datos.mes}&Anio=${datos.anio}`})
        .then(({ data }) => {
          resolve(data)
        })
        .catch(({ response }) => {
          reject(response);
        })
    })
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_CONCILIACIONES](state, conciliaciones) {
    state.error = {};
    state.conciliaciones = conciliaciones;
  },
  [SET_ORDERS](state, orders) {
    state.error = {};
    state.orders = orders;
  },
  [SET_DETAILS](state, details) {
    state.error = {};
    state.details = details;
  },
  [SET_ORDER](state, data) {
    state.error = {};
    state.order = data;
  },
};

export default {
  state,
  actions,
  mutations,
};
